import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger
} from '@components/ui/hover-card';
import type { PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

type Props = PropsWithChildren<{
  title?: string;
  description?: string;
  triggerClassName?: string;
  additionalContent?: React.ReactNode;
  cardContent?: React.ReactNode;
  noIcon?: boolean;
}>;
/** Use `InfoTooltip` inside a relative element. */
export const InfoTooltip = (props: Props) => (
  <HoverCard openDelay={100}>
    <HoverCardTrigger asChild>
      {props.children ?? (
        <span>
          <InfoTooltipIcon noIcon={props.noIcon} />
        </span>
      )}
    </HoverCardTrigger>
    <HoverCardContent className="w-80">
      {props.cardContent ?? (
        <div className="space-y-2 font-normal">
          <div className="space-y-1">
            {props.title && (
              <h4 className="font-semibold text-sm">{props.title}</h4>
            )}
            {props.description && (
              <p className="text-sm">{props.description}</p>
            )}
          </div>
          {props.additionalContent}
        </div>
      )}
    </HoverCardContent>
  </HoverCard>
);

type InfoTooltipIconProps = { noIcon?: boolean; className?: string };

const InfoTooltipIcon = ({
  noIcon = false,
  className
}: InfoTooltipIconProps) => {
  if (noIcon) {
    return <></>;
  }
  return (
    <div
      className={cn(
        'flex aspect-square h-[14px] w-[14px] shrink-0 cursor-pointer select-none items-center justify-center rounded-full bg-gray-100 p-1 font-medium text-[10px] text-gray-900 hover:bg-gray-300',
        className
      )}
    >
      ?
    </div>
  );
};

type ExempleTooltipProps = {
  input: string;
  output: string;
  exampleName?: string;
};
export const ExempleTooltip = ({
  input,
  output,
  exampleName
}: ExempleTooltipProps) => (
  <section className="flex flex-col gap-2 text-gray-800 text-sm">
    <i className="font-semibold">
      Example{exampleName ? `: ${exampleName}` : ''}
    </i>
    <div className="border-gray-300 border-l-2 border-solid pl-2">
      <p>
        Input: <span className="text-blue-600">{input}</span>
      </p>
      <p>
        Output: <span className="font-semibold text-blue-600">{output}</span>
      </p>
    </div>
  </section>
);
